import {computed} from 'vue';
import {useLocalePrefix, useRequestURL} from '#imports';

/**
 * Current-page path to send after sign-in.
 * Omitted on the homepage so login does not bounce back to a cached CMS home.
 */
export function useSigninRedirectUrl() {
    const url = useRequestURL();
    const {withoutLocalePrefix} = useLocalePrefix();

    const signinRedirectUrl = computed(() => {
        if (withoutLocalePrefix(url.pathname) === '/') {
            return undefined;
        }
        return `${url.pathname}${url.search}`;
    });

    const signinRedirectQuery = computed(() => (signinRedirectUrl.value ? `&redirect=${encodeURIComponent(signinRedirectUrl.value)}` : ''));

    return {
        signinRedirectUrl,
        signinRedirectQuery,
    };
}
